import { render, staticRenderFns } from "./EditIcon.vue?vue&type=template&id=54d9c22a"
import script from "./EditIcon.vue?vue&type=script&lang=ts"
export * from "./EditIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports